"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
function toQueryString(collection) {
    var query = _.keys(collection)
        .map(function (key) { return key + "=" + collection[key]; })
        .join('&');
    return query;
}
exports.toQueryString = toQueryString;
